import React from 'react';
import { CTAsWrapper, GroupOfCTAs, ShowResultsCTA, ResetFilters } from './CtaGroup.style';

interface CtaGroupProps {
  onReset: () => void;
  totalCount: number;
  closeFilter: () => void;
}

const CtaGroup: React.FC<CtaGroupProps> = ({ onReset, totalCount, closeFilter }) => {
  const isZeroResults = totalCount === 0;

  const resetAllFilters = () => {
    onReset();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <CTAsWrapper data-testid="filters-main-ctas-wrapper">
      <GroupOfCTAs>
        <ShowResultsCTA
          data-testid="apply-filters-cta"
          isZeroResults={isZeroResults}
          onClick={closeFilter}
        >
          Finish and close
        </ShowResultsCTA>
        <ResetFilters data-testid="reset-filters-cta" onClick={resetAllFilters}>
          Reset Filters
        </ResetFilters>
      </GroupOfCTAs>
    </CTAsWrapper>
  );
};

export default CtaGroup;
